import SearchResult from './SearchResult'
import withSearchResult from './withSearchResult'

const ConnectedSearchResult = withSearchResult(SearchResult)

export { ConnectedSearchResult as SearchResult }
